import React from 'react';
import { Form, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTestMode } from '../../contexts/TestModeContext';

const TestModeToggle = () => {
	const { testMode, toggleTestMode } = useTestMode();

	const tooltip = (
		<Tooltip id="test-mode-tooltip">
			<strong>Test Mode:</strong><br />
			{testMode ? (
				<>
					ON - Only test students are shown and editable.<br />
					Real students are protected (locked).
				</>
			) : (
				<>
					OFF - Normal operation.<br />
					Real students are editable, test students are hidden.
				</>
			)}
		</Tooltip>
	);

	return (
		<div className='d-flex align-items-center'>
			<OverlayTrigger placement="bottom" overlay={tooltip}>
				<div className='d-flex align-items-center' style={{ cursor: 'help' }}>
					<Badge
						bg={testMode ? 'warning' : 'secondary'}
						className='me-2'
						style={{ fontSize: '0.75rem' }}
					>
						{testMode ? (
							<>
								<i className='fa-sharp fa-solid fa-flask me-1'></i>TEST MODE
							</>
						) : 'PRODUCTION'}
					</Badge>
					<Form.Check
						type="switch"
						id="test-mode-switch"
						checked={testMode}
						onChange={toggleTestMode}
						label=""
						className='mb-0'
						style={{
							transform: 'scale(1.2)',
						}}
					/>
				</div>
			</OverlayTrigger>
		</div>
	);
};

export default TestModeToggle;
